// packages/content/src/catalog/shells.ts — weight = relative chance in shellsFor
import type { CatalogEntry } from '../schema/catalog';
export default [
  { id: 'shell.cockle', kind: 'shell', name: 'nature.cockle', sell: 60, stack: 10, weight: 30 },
  { id: 'shell.cowrie', kind: 'shell', name: 'nature.cowrie', sell: 80, stack: 10, weight: 25 },
  { id: 'shell.scallop', kind: 'shell', name: 'nature.scallop', sell: 120, stack: 10, weight: 20 },
  { id: 'shell.sand_dollar', kind: 'shell', name: 'nature.sandDollar', sell: 150, stack: 10, weight: 15 },
  { id: 'shell.conch', kind: 'shell', name: 'nature.conch', sell: 400, stack: 10, weight: 10 },
] as const satisfies readonly CatalogEntry[];
